// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  margin-right: 1%;
}

.header-row {
  width: 100%;
}

.table {
  overflow-y: scroll !important;
  padding-top: 3px;
}

.view-link {
  vertical-align: middle;
}

.table-header {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
}

.link-text {
  font-family: Inter, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.254903px;
  color: #055C8D;
}

.link-text .map-link-text {
  padding: 0 5px 0 2px;
}

.secondary {
  margin-left: 5px;
}

.primary {
  margin-left: 5px;
}

.view-link-content {
  align-items: center !important;
}
.view-link-content:focus {
  outline: none !important;
}

.view-link-content .map-link {
  left: 20px;
}

*:focus {
  outline: none !important;
}

.map {
  margin-right: 20px;
}

.map-row {
  height: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
